import PropTypes from 'prop-types';

export const VariantShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
  }),
  compareAtPrice: PropTypes.shape({
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
  }),
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
  }).isRequired,
  product: PropTypes.shape({
    handle: PropTypes.string,
    productType: PropTypes.string,
  }),
  quantityAvailable: PropTypes.number,
});

export const AttributesShape = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })
);
